import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemSide from './item-side/ItemSide'
import LazyLoad from 'react-lazyload'

class OrderMockUp extends Component {
    render() {
        const {mockUpFront, mockUpBack, mockUpSleeves, mockUpHood, lazyload, ...rest} = this.props

        return (
            <td className='OrderMockUp'>
                {
                    lazyload ? 
                    <LazyLoad>
                        <div className='d-flex no-gutters'>
                            <div className='col-6 p-1'>
                                <ItemSide {...rest} type='update-mock-up' side='front' url={mockUpFront} layout='image'/>
                            </div>

                            <div className='col-6 p-1'>
                                <ItemSide {...rest} type='update-mock-up' side='back' url={mockUpBack} layout='image'/>
                            </div>
                        </div>
                    </LazyLoad> :
                    <div className='d-flex no-gutters'>
                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-mock-up' side='front' url={mockUpFront} layout='image'/>
                        </div>

                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-mock-up' side='back' url={mockUpBack} layout='image'/>
                        </div>
                    </div>
                }
            </td>
        )
    }
}

OrderMockUp.defaultProps = {
    mockUpFront: '',
    mockUpBack: '',
}

OrderMockUp.propTypes = {
    mockUpFront: PropTypes.string,
    mockUpBack: PropTypes.string,
}

export default OrderMockUp
